export default __webpack_public_path__ + "static/media/designation-16px.02b4cf52.svg";